import {getUserDetails, updateUserInfo, delUser} from '../requests/user';
import {getOrganizationDetails} from "../requests";
import {getInfoUser} from "./manageUsers";
import {getAllDevices} from "./devices";
import {getAllStations} from "./stations";

import {changePassword as changeUserPassword} from '../requests/user';
import async from 'async';
import {listUsers} from "./organizations";

export const GET_USER_INFO = 'GET_USER_INFO';
export const UPDATE_ORG = 'UPDATE_ORG';
export const LOGGED_OUT = 'LOGGED_OUT';

export const getUserInfo = () => {
    return (dispatch) => {
        getUserDetails(sessionStorage.getItem('x-auth-token'), (user, err) => {
            if (!err) {
                user.admin = user.roles[0].name === 'Admin';
                if(user.admin)
                    dispatch(getAllDevices());
                dispatch(getAllStations(user.admin));
                async.eachOf(user.organizations, (org, i, cb) => {
                    getOrganizationDetails(sessionStorage.getItem('x-auth-token'), org.id, (response, err) => {
                        if (err) {
                            console.log(response);
                            cb();
                        } else {
                            user.organizations[i] = response;
                            cb();
                        }
                    });
                }, err => {
                    if (err) console.log(err);

                    if (user.organizations.length > 0)
                        user.currentOrganization = user.organizations[0];
                    else
                        user.currentOrganization = null;

                    dispatch({
                        type: GET_USER_INFO,
                        user
                    });
                });
            } else {
                console.log(user);
            }
        });
    }
};

export const updateOrg = (organization) => {
    return dispatch => {
        dispatch({
            type: UPDATE_ORG,
            organization
        })
    }
};

export const updateUser = (email, user, callback) => {
    return dispatch => {
        updateUserInfo(email, user, sessionStorage.getItem('x-auth-token'), (response, err) => {
            if (!err) {
                dispatch({
                    type: GET_USER_INFO,
                    user: response
                });
                callback(response, err)
            } else if (user.status === 401 && err)
                null; //dispatch(setLoggedOutUser()); TODO
            else callback(response, err)
        });
    }
};


export const deleteUser = (user, callback) => {
    return dispatch => {
        delUser(user, sessionStorage.getItem('x-auth-token'), (response, error) => {
            if (error)
                console.log(response);
            else {
                callback(response, error);
                dispatch(listUsers());
            }
        });
    }
};

export const editUser = (user) => {
    return (dispatch) => {
        dispatch(getInfoUser(user.email));
    }
};

/**
 *
 * @param password {{password:string, original_password:string}}
 * @returns {function(*, *)}
 */
export const changePassword = (password, callback) => {
    return (dispatch, getState) => {

        changeUserPassword(getState().user.id, password, sessionStorage.getItem('x-auth-token'), (resp, error) => {
            if (!error) {
                // getUserToken({
                //     "user": {
                //         "name": getState().user.email,
                //         "password": password.password
                //     }
                // }, (response, err) => {
                //     if (!err) {
                //         localStorage.setItem('x-auth-token', response.headers["x-subject-token"]);
                //         localStorage.setItem('user', response.data.token.user.name);
                //
                //         //dispatch(loginUser(response.data.token, response.data.organizations, response.headers["x-subject-token"]));
                //     }
                // });

                callback(null, false);
            } else {
                if (resp.status === 401)
                    null; //dispatch(setLoggedOutUser()); TODO
                else
                    callback(resp, true);
            }
        })
    }
};


export const logOutUser = () => {
    return (dispatch) => {
        dispatch({
            type: LOGGED_OUT
        })
    }
};



// WEBPACK FOOTER //
// ./src/actions/user.js